(function() { window.GUID_713bfda9_27e1_44fa_83d3_edc53620e6bd = { getGuid: function() { return "713bfda9-27e1-44fa-83d3-edc53620e6bd"; } }; })();
//TODO:POP
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class CSError {
            constructor() {
                let me = this;
                CSError.Current = this;
                this.$container = $('#error-container-dropdown');
                this.$inner = this.$container.find('.inner');
                this.$container.offon('click.error', 'button', function () {
                    me.Hide();
                });
            }
            Show(error) {
                this.$inner[0].innerHTML = error.message;
                this.$container.append("<style> body {overflow: hidden;} </style>");
                //btn-close-error vient de la version CS.Web, cest pourquoi je l'enleve
                this.$container.find('#btn-close-error').remove();
                this.$container.slideDown();
                let me = this;
                CS.PopState.WaitForPop('errorpop', () => {
                    if (error.isNavigationError) {
                        CS.Nav.Refresh();
                    }
                    else {
                        me.Hide();
                    }
                });
            }
            Hide() {
                let me = this;
                this.$container.slideUp(150, () => {
                    me.$inner.empty();
                    me.$container.find('style').remove();
                });
                CS.Events.Trigger('errorclosed');
                CS.PopState.GoBackIfNotAlreadyDone();
            }
            generateDefaultMessage(error) {
                return `<div class='error control-cs' id="error-container"><h4 id="generic-message">Error ${error.statusCode}</h4><p id="exception">${error.error}</p></div>`;
            }
        }
        Controls.CSError = CSError;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=error.js.map
